/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetReportAssignedUsersParams, ReportUserDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />
 */
export const assignReportToUser = (
  userId: string,
  reportId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ReportUserDto>(
    {
      url: `/api/${userId}/reports/${reportId}/users/${id}`,
      method: 'PUT',
      signal,
    },
    options
  );
};

export const getAssignReportToUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignReportToUser>>,
    TError,
    { userId: string; reportId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignReportToUser>>,
  TError,
  { userId: string; reportId: number; id: number },
  TContext
> => {
  const mutationKey = ['assignReportToUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignReportToUser>>,
    { userId: string; reportId: number; id: number }
  > = (props) => {
    const { userId, reportId, id } = props ?? {};

    return assignReportToUser(userId, reportId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignReportToUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignReportToUser>>
>;

export type AssignReportToUserMutationError = ErrorType<unknown>;

export const useAssignReportToUser = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignReportToUser>>,
      TError,
      { userId: string; reportId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof assignReportToUser>>,
  TError,
  { userId: string; reportId: number; id: number },
  TContext
> => {
  return useMutation(
    getAssignReportToUserMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />
 */
export const unassignReportFromUser = (
  userId: string,
  reportId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/reports/${reportId}/users/${id}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getUnassignReportFromUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unassignReportFromUser>>,
    TError,
    { userId: string; reportId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unassignReportFromUser>>,
  TError,
  { userId: string; reportId: number; id: number },
  TContext
> => {
  const mutationKey = ['unassignReportFromUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unassignReportFromUser>>,
    { userId: string; reportId: number; id: number }
  > = (props) => {
    const { userId, reportId, id } = props ?? {};

    return unassignReportFromUser(userId, reportId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnassignReportFromUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof unassignReportFromUser>>
>;

export type UnassignReportFromUserMutationError = ErrorType<unknown>;

export const useUnassignReportFromUser = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unassignReportFromUser>>,
      TError,
      { userId: string; reportId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof unassignReportFromUser>>,
  TError,
  { userId: string; reportId: number; id: number },
  TContext
> => {
  return useMutation(
    getUnassignReportFromUserMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getReportAssignedUsers = (
  userId: string,
  reportId: number,
  params?: GetReportAssignedUsersParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ReportUserDto[]>(
    {
      url: `/api/${userId}/reports/${reportId}/users`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetReportAssignedUsersQueryKey = (
  userId: string,
  reportId: number,
  params?: GetReportAssignedUsersParams
) => {
  return [
    `/api/${userId}/reports/${reportId}/users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReportAssignedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportAssignedUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  reportId: number,
  params?: GetReportAssignedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportAssignedUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReportAssignedUsersQueryKey(userId, reportId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportAssignedUsers>>
  > = ({ signal }) =>
    getReportAssignedUsers(userId, reportId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && reportId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportAssignedUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportAssignedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportAssignedUsers>>
>;
export type GetReportAssignedUsersQueryError = ErrorType<unknown>;

export function useGetReportAssignedUsers<
  TData = Awaited<ReturnType<typeof getReportAssignedUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  reportId: number,
  params: undefined | GetReportAssignedUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportAssignedUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportAssignedUsers>>,
          TError,
          Awaited<ReturnType<typeof getReportAssignedUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportAssignedUsers<
  TData = Awaited<ReturnType<typeof getReportAssignedUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  reportId: number,
  params?: GetReportAssignedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportAssignedUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportAssignedUsers>>,
          TError,
          Awaited<ReturnType<typeof getReportAssignedUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportAssignedUsers<
  TData = Awaited<ReturnType<typeof getReportAssignedUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  reportId: number,
  params?: GetReportAssignedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportAssignedUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetReportAssignedUsers<
  TData = Awaited<ReturnType<typeof getReportAssignedUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  reportId: number,
  params?: GetReportAssignedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportAssignedUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReportAssignedUsersQueryOptions(
    userId,
    reportId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
